import { render } from "./AddSecteurActivitePage.vue?vue&type=template&id=616bf528&ts=true"
import script from "./AddSecteurActivitePage.vue?vue&type=script&lang=ts"
export * from "./AddSecteurActivitePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__